import React from "react";
import { useTranslation } from "react-i18next";

import Container from "Components/Container/Container";

/**
 * Trailer hero content — title + instructor + description.
 *
 * Desktop (lg+): UNCHANGED from the original — text-6xl title, white
 *                 underline at -bottom-6, lg:w-1/3 (RTL) / lg:w-1/2 (LTR),
 *                 absolutely positioned over the left side of the video.
 * Mobile:         instructor name + description are now visible (used to be
 *                 hidden lg:block); smaller title size, tighter spacing.
 */
const TrailerContent = ({ isPlaying, data }) => {
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";

  // Don't render content when video is playing
  if (isPlaying) return null;

  return (
    <div className="flex flex-col justify-center w-full mt-4 lg:mt-0 lg:absolute lg:h-full lg:top-1/2 lg:-translate-y-1/2 lg:left-0 z-10">
      <Container>
        <div className={`${isRTL ? "lg:w-1/3" : "lg:w-1/2"}`}>
          {/* Course Title — desktop kept verbatim (text-6xl + original underline
              -bottom-6 / w-[62px] / h-1). Mobile is tighter: 20px base, 24px
              sm, with a proportionally smaller underline so it doesn't dwarf
              the text. */}
          <h1
            className={`
              text-white font-bold leading-tight
              text-xl sm:text-2xl md:text-4xl lg:text-6xl
              relative
              after:absolute after:bg-white after:rounded-full
              after:w-8 after:h-0.5 lg:after:w-[62px] lg:after:h-1
              after:-bottom-2 lg:after:-bottom-6
              ${isRTL ? "after:right-0" : "after:left-0"}
            `}
          >
            {data?.name}
          </h1>

          {/* Instructor Name — desktop unchanged; mobile now visible */}
          {data?.instructor?.name && (
            <p className="mt-8 lg:mt-0 lg:pt-12 text-white text-base lg:text-2xl">
              {data.instructor.name}
            </p>
          )}

          {/* Course Description — desktop unchanged; mobile now visible */}
          {data?.description && (
            <div
              className={`
                mt-3 lg:mt-6 text-sm text-white/80 leading-relaxed
                lg:text-xl lg:text-white
                ${isRTL ? "lg:leading-relaxed" : ""}
              `}
              dangerouslySetInnerHTML={{ __html: data.description }}
            />
          )}
        </div>
      </Container>
    </div>
  );
};

export default TrailerContent;
